export default {
  rollover: {
    title: '賭け条件',
    detailsTitle: '賭け条件の詳細',
    all: 'すべて',
    allStats: 'すべてのステータス',
    select: '選択',
    rolloverType: '賭け条件の種類',
    amount: '金額',
    source: '取得元',
    wallet: 'ウォレット',
    current: '現在',
    wagered: '賭け済み',
    required: '必要額',
    progress: '進捗',
    loading: '読み込み中...',
    noData: 'データがありません',
    noMoreData: 'これ以上データはありません',
    state: '状態',
    type: '種類',
    createdOn: '作成日時',
    wageringRequirement: '賭け条件',
    currency: '通貨',
    wagerRequired: '必要賭け額',
    wagerCompleted: '賭け完了額',
    cash: 'キャッシュ',
    bonus: 'ボーナス',
  },
};
